/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Box, Chip, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  chip: {
    marginRight: theme.spacing(0.5),
  },
  chipAdmin: {
    backgroundColor: theme.palette.black,
    color: theme.palette.white,
  },
  chipDrafter: {
    backgroundColor: theme.palette.roleChip.DRAFTER.main,
    color: theme.palette.roleChip.DRAFTER.contrastText,
  },
  chipSigner: {
    backgroundColor: theme.palette.roleChip.SIGNER.main,
    color: theme.palette.roleChip.SIGNER.contrastText,
  },
  chipSender: {
    backgroundColor: theme.palette.roleChip.SENDER.main,
    color: theme.palette.roleChip.SENDER.contrastText,
  },
  chipPayer: {
    backgroundColor: theme.palette.roleChip.PAYER.main,
    color: theme.palette.roleChip.PAYER.contrastText,
  },
  chipDefault: {
    backgroundColor: theme.palette.roleChip.DEFAULT.main,
    color: theme.palette.roleChip.DEFAULT.contrastText,
  },
}));

export function SwitchAccountUserRoles({ className, roles = [] }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const roleStyles = {
    PAYER: classes.chipPayer,
    DRAFTER: classes.chipDrafter,
    SENDER: classes.chipSender,
    END_USER_ADMIN: classes.chipAdmin,
    SIGNER: classes.chipSigner,
    Default: classes.chipDefault,
  };

  return (
    <Box component="ul" className={className}>
      {roles.map((role) => {
        const roleName = role.replace(/^ROLE_/, '');
        const style = roleStyles[roleName] || roleStyles.Default;
        return (
          <li key={role}>
            <Chip label={t(role)} className={clsx(classes.chip, style)} />
          </li>
        );
      })}
    </Box>
  );
}
